
import { NHSGrade, InterviewType } from '@shared/types';

export const SPECIALTIES = [
  'Dental',
  'GP out of Hours',
  'Major Trauma',
  'Accident and Emergency',
  'Acute Medicine',
  'Anaesthesia',
  'Audiological Medicine',
  'Breast Radiology',
  'Breast Screening',
  'Breast Surgery',
  'Cardiology',
  'Cardiothoracic Surgery',
  'Clinical Neurophysiology',
  'Clinical Pharmacology',
  'Dermatology',
  'Ear, Nose & Throat',
  'Endocrinology and Diabetes',
  'Endoscopy',
  'Examiner',
  'Gastroenterology',
  'General',
  'General Practice',
  'General Practice Vocational Training Schemes',
  'Genetics',
  'Genitourinary Medicine',
  'Geriatric Medicine',
  'Haematology',
  'Hepatology / Liver Disorders',
  'Infectious Diseases',
  'Intensive Care',
  'Management',
  'Medicine',
  'Microbiology',
  'Neonatal Medicine',
  'Nephrology',
  'Neurology',
  'Neurosurgery',
  'Nuclear Medicine',
  'Obstetrics and Gynaecology',
  'Occupational Health',
  'Oncology',
  'Ophthalmology',
  'Oral and Maxillofacial Surgery',
  'Otolaryngology',
  'Paediatric Cardiology',
  'Paediatric Neurology',
  'Paediatric Oncology',
  'Paediatric Surgery',
  'Paediatrics',
  'Pain Management',
  'Palliative Medicine',
  'Pathology & Histopathology',
  'Plastic Surgery',
  'Psychiatry - Child / Adolescent',
  'Psychiatry - Drug / Alcohol / Substance Misuse',
  'Psychiatry - Elderly',
  'Psychiatry - Forensic',
  'Psychiatry - General',
  'Public and Community Health',
  'Radiology',
  'Rehabilitation Medicine',
  'Respiratory Medicine',
  'Rheumatology',
  'Sexual and Reproductive Health Clinics',
  'Spinal Injuries',
  'Surgery',
  'Trauma and Orthopaedic Surgery',
  'University, Research and Fellowships',
  'Urology'
];

export const GRADES = Object.values(NHSGrade);
export const INTERVIEW_TYPES = Object.values(InterviewType);

export const NHS_VALUES = [
  'Working together for patients',
  'Respect and dignity',
  'Commitment to quality of care',
  'Compassion',
  'Improving lives',
  'Everyone counts'
];

export const SCORING_DOMAINS = [
  'Communication',
  'Patient Safety',
  'NHS Values',
  'Clinical Reasoning',
  'Leadership',
  'Prioritisation',
  'Professionalism'
];
